import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path d="M1.3 6.7C.6 6.7 0 7.3 0 8s.6 1.3 1.3 1.3c.7 0 1.3-.6 1.3-1.3.1-.7-.5-1.3-1.3-1.3zm0 5.3c-.7 0-1.3.6-1.3 1.3s.6 1.3 1.3 1.3c.7 0 1.3-.6 1.3-1.3.1-.7-.5-1.3-1.3-1.3zm5.4-8h8c.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3h-8c-.7 0-1.3.6-1.3 1.3-.1.7.5 1.3 1.3 1.3zm8 2.7h-8c-.8 0-1.4.6-1.4 1.3s.6 1.3 1.3 1.3h8c.8 0 1.4-.6 1.4-1.3s-.6-1.3-1.3-1.3zM1.3 1.3C.6 1.3 0 1.9 0 2.7S.6 4 1.3 4c.7 0 1.3-.6 1.3-1.3.1-.8-.5-1.4-1.3-1.4zM14.7 12h-8c-.7 0-1.3.6-1.3 1.3 0 .7.6 1.3 1.3 1.3h8c.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3z" />
  </svg>
);
